/** One `offset-x` / `offset-y` attribute: a finite number, or `undefined` when absent / blank / not numeric. */
function axis(raw: string | null): number | undefined {
  if (raw === null || raw.trim() === "") return undefined;
  const n = Number(raw);
  return Number.isFinite(n) ? n : undefined;
}

/** Host launcher offset from the two attributes, PER AXIS: only the axes the host set are present, so the
 *  integration's `theme.launcherOffset` still applies to the other. `undefined` when neither is set. */
export function readOffsetAttrs(
  x: string | null,
  y: string | null,
): { x?: number; y?: number } | undefined {
  const ax = axis(x);
  const ay = axis(y);
  if (ax === undefined && ay === undefined) return undefined;
  return { ...(ax === undefined ? {} : { x: ax }), ...(ay === undefined ? {} : { y: ay }) };
}
